import colors from "./colors/index";
import icons from "./icons";
import * as meta from "./meta";
import typography from "./typography";
import * as sizes from "./sizes";
import { flattenObject } from "../js/utilities/flatten-object";
import renderDesignTokens from "./render-design-token";

/**
 * Import the tokens and render the props according to cssOutput
 * @param {Boolean} cssOutput define when exporting tokens as CSS or not
 * @returns Object
 */
export default (cssOutput) => {
    if (cssOutput) {
        return renderDesignTokens(
            flattenObject(
                {
                    colors,
                    typography,
                    sizes,
                },
                true
            ),
            true
        );
    }

    return renderDesignTokens(
        flattenObject(
            {
                typography,
                icons,
                colors,
                meta,
                sizes,
            },
            true
        )
    );
};
